// Shared helpers for FIT slab (Hotel Options) pricing.

export const activePlans = (opt) => (opt?.meal_plans || []).filter(Boolean);

// First active meal plan that has at least one non-zero price (avoids defaulting to an empty column).
export const firstPricedPlan = (opt) => {
  const plans = activePlans(opt);
  for (const p of plans) {
    if ((opt?.pax_rows || []).some((r) => Number(r.prices?.[p] || 0) > 0)) return p;
  }
  return plans[0] || "";
};

// A FIT tour uses the new grid when it has at least one hotel option with pax rows.
export const hasFitGrid = (tour) =>
  tour?.package_type !== "GROUP" &&
  Array.isArray(tour?.hotel_options) &&
  tour.hotel_options.some((o) => (o.pax_rows || []).length > 0);

// Lowest per-person price across every option / row / active meal plan.
export const lowestPP = (tour) => {
  let min = Infinity;
  (tour?.hotel_options || []).forEach((o) =>
    (o.pax_rows || []).forEach((r) =>
      activePlans(o).forEach((p) => {
        const v = Number(r.prices?.[p] || 0);
        if (v > 0 && v < min) min = v;
      })
    )
  );
  return min === Infinity ? 0 : min;
};

// Pax rows in an option that match a given adult count.
export const rowsForPax = (opt, pax) =>
  (opt?.pax_rows || []).filter((r) => Number(r.pax) === Number(pax));

// Is a date allowed? The whole stay (all nights) must fit inside a single window.
export const dateAllowed = (windows, dateStr, nights = 0) => {
  const w = (windows || []).filter((x) => x.start && x.end);
  if (!w.length) return true; // no restriction configured
  if (!dateStr) return false;
  const lastNight = nights > 0 ? addDays(dateStr, nights - 1) : dateStr;
  return w.some((x) => dateStr >= x.start && lastNight <= x.end);
};

export const fmtWindow = (w) => {
  const f = (d) =>
    d ? new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "";
  return `${f(w.start)} → ${f(w.end)}`;
};

// Nights from a duration string like "6 Days / 5 Nights".
export const tourNights = (tour) => {
  const d = tour?.duration || "";
  let m = /([0-9]+)\s*Night/i.exec(d);
  if (m) return parseInt(m[1], 10);
  m = /([0-9]+)\s*Day/i.exec(d);
  if (m) return Math.max(0, parseInt(m[1], 10) - 1);
  return 0;
};

export const addDays = (dateStr, n) => {
  const dt = new Date(dateStr + "T00:00:00");
  dt.setDate(dt.getDate() + n);
  return dt.toISOString().slice(0, 10);
};
